<template>
  <div>
    <Preloader v-if="loading" />
    <div
      v-else
      :class="`col-md-3 widget_price_filter widget_product_categories${
        filtersMobile ? ' active_filter' : ''
      }`"
    >
      <template v-if="$mq.stablet">
        <div class="close-filter_btn" @click="toggleFilter()">X</div></template
      >
      <div v-for="filter in categoryFilters" :key="filter.slug">
        <div class="title">
          {{ filterName(filter) }}
        </div>
        <ul
          v-if="filter.slug == 'model'"
          class="woocommerce-widget-layered-nav-list"
        >
          <li
            v-if="filterSelection(filter.slug)"
            class="woocommerce-widget-layered-nav-list__item wc-layered-nav-term woocommerce-widget-layered-nav-list__item--chosen chosen"
          >
            <a
              href="#"
              rel="nofollow"
              @click.stop.prevent="onUnsetFilter(filter.slug)"
            >
              {{ filterSelection(filter.slug) }}
            </a>
          </li>
          <li
            v-else
            v-for="(option, i) in useModelsFilters(filter.options)"
            class="woocommerce-widget-layered-nav-list__item wc-layered-nav-term${isChosenOptionClass"
            :class="isChosenOptionClass(filter, option) ? ' chosen' : ''"
            :key="`${filter.slug}_${option.slug}_${i + 1}`"
          >
            <a
              href="#"
              rel="nofollow"
              @click.stop.prevent="onSetFilter(filter.slug, option.slug)"
              :title="`${filter.slug},${option.slug}`"
            >
              {{ filterName(option) }}
            </a>
            <!--<span class="count">(57)</span>-->
          </li>
        </ul>
        <ul
          v-if="filter.slug !== 'model'"
          class="woocommerce-widget-layered-nav-list"
        >
          <li
            v-if="filterSelection(filter.slug)"
            class="woocommerce-widget-layered-nav-list__item wc-layered-nav-term woocommerce-widget-layered-nav-list__item--chosen chosen"
          >
            <a
              href="#"
              rel="nofollow"
              @click.stop.prevent="onUnsetFilter(filter.slug)"
            >
              {{ filterSelection(filter.slug) }}
            </a>
          </li>
          <li
            v-else
            v-for="(option, i) in filter.options"
            class="woocommerce-widget-layered-nav-list__item wc-layered-nav-term${isChosenOptionClass"
            :class="isChosenOptionClass(filter, option) ? ' chosen' : ''"
            :key="`${filter.slug}_${option.slug}_${i + 1}`"
          >
            <a
              :href="getPath(filter.slug, option.slug)"
              :rel="getRel(filter.slug, option.slug)"
              @click.stop.prevent="onSetFilter(filter.slug, option.slug)"
              :title="`${filter.slug},${option.slug}`"
            >
              {{ filterName(option) }}
            </a>
            <!--<span class="count">(57)</span>-->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Preloader from '@/components/Preloader'
import categoryFiltersMixin from '@/components/category/categoryFiltersMixin'

export default {
  name: 'Filters',
  components: { Preloader },
  data() {
    return {
      loading: true,
    }
  },
  mixins: [categoryFiltersMixin],
  computed: {
    ...mapState(['category', 'filters', 'filtersMobile', 'SEOCategoriesMeta']),
    ...mapState({ filtersMobile: (state) => state.filtersMobile }),
  },
  methods: {
    useModelsFilters(list) {
      if (this.category.slug === 'apple-watch') {
        const mapping = {}
        list.forEach((item) => {
          const chain = item.name_ua.trim().split(' ')
          chain.splice(0, 2)
          const type = chain.shift()
          if (!mapping[type]) {
            mapping[type] = []
          }
          const version = chain.pop()
          mapping[type].push({
            ...item,
            version: version ? Number(version) : 1,
          })
        })
        const order = ['Ultra', 'Series', 'SE']
        const sortedList = Object.entries(mapping).sort(
          (a, b) => order.indexOf(a[0]) - order.indexOf(b[0])
        )
        return sortedList.reduce(
          (newList, [, items]) =>
            newList.concat(items.sort((a, b) => b.version - a.version)),
          []
        )
      } else {
        return list.reverse()
      }
    },
    getRel(filter, option) {
      let path = this.getPath(filter, option)
      const { params } = this.$router.currentRoute
      path = params.lang
        ? path.replace(new RegExp(`/${params.lang}`), '')
        : path
      const allowed = this.SEOCategoriesMeta.find(({ url }) => url === path)
      return allowed ? undefined : 'nofollow'
    },
    getPath(filter, option) {
      const { search, pathname } = window.location
      const newParam = `${filter}=${option}`
      const path = `${pathname}${
        search ? `${search}&${newParam}` : `?${newParam}`
      }`

      return path
    },
    updatePath(filter, option) {
      const { path, query } = this.$route

      if (!option) {
        delete query[filter]
      } else {
        query[filter] = option
      }

      const queryValues = Object.entries(query).map(
        ([key, value]) => `${key}=${value}`
      )
      const helper = queryValues.length ? '?' : ''
      const newPath = `${path}${helper}${queryValues.join('&')}`

      history.pushState(query, null, newPath)
    },
    onSetFilter(filter, option) {
      this.$store.dispatch('resetPagination')
      this.$store.commit('setSelectedFilter', { filter, option })
      this.updatePath(filter, option)
      /*if (filter === 'model') {
          this.doCategoryUplift()
        }*/
      this.$forceUpdate()
    },
    onUnsetFilter(slug) {
      this.$store.commit('unsetSelectedFilter', slug)
      this.updatePath(slug)
      this.$forceUpdate()
    },
    filterName(filter) {
      return filter[`name_${this.$i18n.locale}`]
    },
    // return selection translation value by filter slug for current category, undefined if no such filter chosen
    filterSelection(slug) {
      const filterValue = this.$store.state.selectedFilters[slug]
      if (this.category.currentPath) {
        let categorySlug = this.category.currentPath.split('/').shift()
        if (categorySlug === 'used') {
          categorySlug = this.category.currentPath.split('/')[1]
        }
        const filterGroup = this.filters.find(
          (f) => f.category === categorySlug
        )
        if (filterGroup && filterGroup.attributes) {
          const filter = filterGroup.attributes.find((f) => f.slug === slug)
          if (filter) {
            const option = filter.options.find((o) => o.slug === filterValue)
            if (option) {
              return option[`name_${this.$i18n.locale}`]
            }
          }
        }
      }
      return ''
    },
    // isChosenOptionClass(filter) {
    isChosenOptionClass() {
      // return filter.slug === 'model' && filter.options.length === 1
      return false
    },
    toggleFilter() {
      this.setFiltersMobile(!this.filtersMobile)
    },
    ...mapMutations(['setFiltersMobile']),
  },
  watch: {
    filtersMobile: function () {
      document.body.style.overflow = this.filtersMobile ? 'hidden' : ''
      document.querySelector('.overlay_page').style.display = this.filtersMobile
        ? 'block'
        : 'none'
    },
  },
  beforeMount() {
    this.$store
      .dispatch('fetchFilters')
      .then(() => {
        this.loading = false
      })
      .catch((err) => {
        console.log('*[FILTERS FETCH ERROR]', err)
      })
  },
}
</script>

<style></style>
